import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SolicitudPersonaAutorizacionModel, SolicitudesPersonaAutorizacionesModel } from 'src/app/models/commands/acceso-personal/AccesoPersonalRegistrarModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { ISolicitudExtenderModel } from 'src/app/models/interfaces/solicitud/ISolicitudExtenderModel';
import { SolicitudPersonaPendienteAccesoBaseModel } from 'src/app/models/queries/solicitudes/solicitud-persona/SolicitudPersonaPendienteAccesoBaseModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { SolicitudPersonaService } from 'src/app/services/solicitud-persona/solicitud-persona.service';

@Component({
  selector: 'app-solicitud-pendiente-acceso-detalle-dialog',
  templateUrl: './solicitud-pendiente-acceso-detalle-dialog.component.html',
  styleUrls: ['./solicitud-pendiente-acceso-detalle-dialog.component.scss']
})
export class SolicitudPendienteAccesoDetalleDialogComponent implements OnInit {

  checkTodosAutorizados: boolean = false;
  checkTodosRechazados: boolean = false;
  modelListaSolicitudes: SolicitudPersonaPendienteAccesoBaseModel[];
  displayedColumns: string[] = [
    'trabajador',
    'nroDocumentoIdentidad',
    'fechaInduccion',
    'aprobado',
    'desaprobado'
  ];
  constructor(public dialogRef: MatDialogRef<SolicitudPendienteAccesoDetalleDialogComponent>,
    private confirmDialogService: ConfirmDialogService,
    private solicitudPersonaService: SolicitudPersonaService,
    private alertDialogService: AlertDialogService,
    @Inject(MAT_DIALOG_DATA) public idSolicitud: number) {

    this.modelListaSolicitudes = new Array<SolicitudPersonaPendienteAccesoBaseModel>();
  }

  esInvalido(): boolean {
    return this.modelListaSolicitudes.filter(p => p.autorizado || p.rechazado).length == 0;
  }

  search(): void {
    this.solicitudPersonaService.getPendienteAccesoSolicitud(this.idSolicitud).subscribe((data) => {
      this.modelListaSolicitudes = data.items;
    });
  }

  ngOnInit() {
    this.search();
  }

  onNoClick() {
    this.dialogRef.close();
  }

  changeAutorizado(element: SolicitudPersonaPendienteAccesoBaseModel) {
    if (element.autorizado)
      element.rechazado = false;
  }

  changeRechazado(element: SolicitudPersonaPendienteAccesoBaseModel) {
    if (element.rechazado)
      element.autorizado = false;
  }

  changeAutorizadoAll(item: any) {
    console.log(item);
    if (item.checked) {
      this.checkTodosRechazados = false;
      this.modelListaSolicitudes.forEach(element => {
        element.rechazado = false
        element.autorizado = item.checked;
      });
    }
    else {
      this.modelListaSolicitudes.forEach(element => {
        element.autorizado = item.checked;
      });
    }
  }

  changeRechazadoAll(item: any) {
    console.log(item);

    if (item.checked) {
      this.checkTodosAutorizados = false;
      this.modelListaSolicitudes.forEach(element => {
        element.autorizado = false;
        element.rechazado = item.checked;
      });
    }
    else {
      this.modelListaSolicitudes.forEach(element => {
        element.rechazado = item.checked;
      });
    }
  }

  registrarResultados(): void {
    this.confirmDialogService.open('¿Está seguro de enviar la información?'); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        let listaResultados = new SolicitudesPersonaAutorizacionesModel();
        listaResultados.idSolicitud = this.idSolicitud;
        listaResultados.listaSolicitudesPersonal = this.modelListaSolicitudes.filter(p => p.autorizado || p.rechazado).map((p) => {
          let resultado = new SolicitudPersonaAutorizacionModel();
          resultado.idSolicitudPersona = p.idSolicitudPersona;
          resultado.autorizado = p.autorizado;
          resultado.rechazado = p.rechazado;
          resultado.idAccesoPersonal = p.idAccesoPersonal;
          return resultado;
        });

        this.solicitudPersonaService.autorizar(listaResultados).subscribe((result: ActionResultModel) => {
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
          else
            this.dialogRef.close();
        });
      }
    });
  }

}
